<template>
  <div style="color:white;" >
    <v-container fluid class="px-16 my-4">
      <FormulaTable :item="item"/>
    </v-container>
  </div>
</template>

<script>
import FormulaTable from '@/components/Add/NewFormulaTable.vue';

export default {
  props: ['item'],
  name: 'Add',
  components: {
    FormulaTable
  }
}
</script>

<style scoped>

</style>